export enum ERROR {
    IS_REQUIRED = 'IS_REQUIRED',
    INVALID_FORMAT = 'INVALID_FORMAT',
}
